export function generateSvgFromString(svgString: string): string {
  var base64Container = "data:image/svg+xml;base64,";
  base64Container += Buffer.from(svgString).toString("base64");
  return base64Container;
}

export function generateClusterMarker(childMarkerCount: number): string {
  return generateSvgFromString(`
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
      <circle cx="50" cy="50" r="50" fill="#FFF" />
      <text font-size="50px" font-family="sans-serif" x="50%" y="50%" stroke="#000" text-anchor="middle" stroke-width="2px" dy="0.35em">
        ${childMarkerCount}
      </text>
    </svg>
  `);
}

export function generateUnfoldedClusterMarker(): string {
  return generateSvgFromString(`
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
      <circle cx="50" cy="50" r="50" fill="#FFF" />
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0, 0, 50, 50">
        <g transform="translate(13, 12)">
            <path d="M22.22,21.414l-2.607-9.167a.652.652,0,0,0-.627-.473H11.774v-2.7a4.562,4.562,0,1,0-1.3,0v2.7H3.259a.652.652,0,0,0-.627.473L.025,21.415a.652.652,0,0,0,.627.83H21.593a.652.652,0,0,0,.627-.83ZM7.864,4.562A3.258,3.258,0,1,1,11.122,7.82,3.262,3.262,0,0,1,7.864,4.562ZM1.515,20.941l2.236-7.864h6.72v4.562a.652.652,0,1,0,1.3,0V13.077h6.72l2.236,7.864Z" transform="translate(0 0)"/>
        </g>
      </svg>
    </svg>
  `);
}
